/** Keep a damaged URL as an invalid identifier for the page/API to handle, never a router crash. */
export function routeId(value: string): string {
  try { return decodeURIComponent(value); }
  catch { return value; }
}
